var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ehc-page',[_c('ehc-properties',{attrs:{"orgObj":{..._vm.gcvOrg, orgId: _vm.gcvOrgId}},on:{"addProperty":function($event){return _vm.refreshOrg()},"deleteProperty":function($event){return _vm.refreshOrg()}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }